import { render, staticRenderFns } from "./h-svg-icon.vue?vue&type=template&id=4e679dfb"
import script from "./h-svg-icon.vue?vue&type=script&lang=ts"
export * from "./h-svg-icon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports